const tagToastMsg = {
  /**
   *  태그 등록하기 전 필요한 데이터 가져오기
   */
  PREPARE_INSERT_TAG_REQUEST_SUCCESS: '태그 등록하기 전 필요한 데이터 요청하기 성공',
  PREPARE_INSERT_TAG_REQUEST_ERROR: '태그 등록하기 전 필요한 데이터 요청하기 실패',

  /**
   *  태그명 중복검사 요청하기
   */
  CHECK_TAG_NAME_REQUEST_ERROR: '태그명 중복검사 요청하기 실패',

  /**
   *  태그 검색 리스트 요청하기
   */
  GET_TAG_SEARCH_LIST_REQUEST_ERROR: '태그 검색 리스트 요청하기 실패',

  /**
   *  추천 태그 리스트 요청하기
   */
  GET_RECOMMEND_TAG_LIST_REQUEST_ERROR: '추천 태그 리스트 요청하기 실패',

  /**
   *  태그 등록 요청하기
   */
  GET_TAG_DETAIL_PREVIEW_DATA_REQUEST_ERROR: '태그 상세 미리보기 데이터 요청히기 실패',

  /**
   *  태그 등록 요청하기
   */
  INSERT_TAG_REQUEST_SUCCESS: '태그 등록 요청하기 성공',
  INSERT_TAG_REQUEST_ERROR: '태그 등록 요청하기 실패',

  /**
   *  태그 편집 요청하기
   */
  EDIT_TAG_REQUEST_SUCCESS: '태그 등록 편집하기 성공',
  EDIT_TAG_REQUEST_ERROR: '태그 등록 편집하기 실패',

  /**
   *  태그 리스트 요청하기
   */
  GET_TAG_LIST_REQUEST_SUCCESS: '태그 리스트 요청하기 성공',
  GET_TAG_LIST_REQUEST_ERROR: '태그 리스트 요청하기 실패',

  /**
   *  태그 상세 내역 요청하기
   */
  GET_TAG_HISTORY_REQUEST_SUCCESS: '태그 상세 내역 요청하기 성공',
  GET_TAG_HISTORY_REQUEST_ERROR: '태그 상세 내역 요청하기 실패',

  /**
   *  태그 상세 내역에 연결된 아이템 리스트 요청하기
   */
  GET_TAG_HISTORY_RELATED_ITEM_LIST_REQUEST_SUCCESS: '태그 상세 내역에 연결된 아이템 리스트 요청하기 성공',
  GET_TAG_HISTORY_RELATED_ITEM_LIST_REQUEST_ERROR: '태그 상세 내역에 연결된 아이템 리스트 요청하기 실패',

  /**
   *  태그 그룹명 중복검사 요청하기
   */
  CHECK_TAG_GROUP_NAME_REQUEST_ERROR: '태그 그룹명 중복검사 요청하기 실패',

  /**
   *  태그 그룹에 연결할 아이템 리스트 요청하기
   */
  GET_TAG_GROUP_ITEM_LIST_REQUEST_SUCCESS: '태그 그룹에 연결할 아이템 리스트 요청하기 성공',
  GET_TAG_GROUP_ITEM_LIST_REQUEST_ERROR: '태그 그룹에 연결할 아이템 리스트 요청하기 실패',

  /**
   *  태그 그룹 등록 요청하기
   */
  INSERT_TAG_GROUP_REQUEST_SUCCESS: '태그 그룹 등록 요청하기 성공',
  INSERT_TAG_GROUP_REQUEST_ERROR: '태그 그룹 등록 요청하기 실패',

  /**
   *  태그 그룹 리스트 요청하기
   */
  GET_TAG_GROUP_LIST_REQUEST_SUCCESS: '태그 그룹 리스트 요청하기 성공',
  GET_TAG_GROUP_LIST_REQUEST_ERROR: '태그 그룹 리스트 요청하기 실패',

  /**
   *  태그 그룹 상세 요청하기
   */
  GET_TAG_GROUP_DETAIL_REQUEST_SUCCESS: '태그 그룹 상세 요청하기 성공',
  GET_TAG_GROUP_DETAIL_REQUEST_ERROR: '태그 그룹 상세 요청하기 실패',

  /**
   *  태그 상세 요청하기
   */
  GET_TAG_DETAIL_REQUEST_SUCCESS: '태그 상세 요청하기 요청하기 성공',
  GET_TAG_DETAIL_REQUEST_ERROR: '태그 상세 요청하기 데이터 요청하기 실패',

  /**
   *  태그 그룹 편집 요청하기
   */
  EDIT_TAG_GROUP_REQUEST_SUCCESS: '태그 그룹 등록 편집하기 성공',
  EDIT_TAG_GROUP_REQUEST_ERROR: '태그 그룹 등록 편집하기 실패',

  /**
   *  태그 등록 거절 요청하기
   */
  REJECT_REGISTRATION_TAG_REQUEST_SUCCESS: '태그 등록 거절 요청하기 성공',
  REJECT_REGISTRATION_TAG_REQUEST_ERROR: '태그 등록 거절 요청하기 실패',

  /**
   *  태그 탭 메인 데이터 요청하기
   */
  GET_TAG_TAB_MAIN_DATA_REQUEST_SUCCESS: '태그 탭 메인 데이터 요청하기 성공',
  GET_TAG_TAB_MAIN_DATA_REQUEST_ERROR: '태그 탭 메인 데이터 요청하기 실패',

  /**
   *  태그 탭 메인에 연결할 컨텐츠 리스트 요청하기
   */
  GET_TAG_TAB_MAIN_CONTENTS_LIST_REQUEST_SUCCESS: '태그 탭 메인에 연결할 컨텐츠 리스트 요청하기 성공',
  GET_TAG_TAB_MAIN_CONTENTS_LIST_REQUEST_ERROR: '태그 탭 메인에 연결할 컨텐츠 리스트 요청하기 실패',

  /**
   *  태그 탭 메인 미리보기 데이터 요청히기
   */
  GET_TAG_TAB_MAIN_PREVIEW_DATA_REQUEST_ERROR: '태그 탭 메인 미리보기 데이터 요청히기 실패',

  /**
   *  태그 탭 메인 편집 요청하기
   */
  EDIT_TAG_TAB_MAIN_REQUEST_SUCCESS: '태그 탭 메인 편집 요청하기 성공',
  EDIT_TAG_TAB_MAIN_REQUEST_ERROR: '태그 탭 메인 편집 요청하기 실패',

  /**
   *  태그 트렌드 키워드 데이터 요청하기
   */
  GET_TREND_KEYWORD_DATA_REQUEST_SUCCESS: '태그 트렌드 키워드 데이터 요청하기 성공',
  GET_TREND_KEYWORD_DATA_REQUEST_ERROR: '태그 트렌드 키워드 데이터 요청하기 실패',

  /**
   *  태그 트렌드 키워드에 연결할 컨텐츠 리스트 요청하기
   */
  GET_TAG_TREND_KEYWORD_CONTENTS_LIST_REQUEST_SUCCESS: '태그 트렌드 키워드에 연결할 컨텐츠 리스트 요청하기 성공',
  GET_TAG_TREND_KEYWORD_CONTENTS_LIST_REQUEST_ERROR: '태그 트렌드 키워드에 연결할 컨텐츠 리스트 요청하기 실패',

  /**
   *  태그 트렌드 키워드 미리보기 데이터 요청히기
   */
  GET_TAG_TREND_KEYWORD_PREVIEW_DATA_REQUEST_ERROR: '태그 트렌드 키워드 미리보기 데이터 요청히기 실패',

  /**
   *  태그 탭 메인 편집 요청하기
   */
  EDIT_TAG_TREND_KEYWORD_REQUEST_SUCCESS: '태그 탭 메인 편집 요청하기 성공',
  EDIT_TAG_TREND_KEYWORD_REQUEST_ERROR: '태그 탭 메인 편집 요청하기 실패',

  /**
   *  [태그 그룹 등록/편집, 태그 메인 탭 관리, 태그 트렌드 키워드 관리]
   *  전체 태그 리스트 엑셀 다운로드 요청하기
   */
  GET_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '전체 태그 리스트 엑셀 다운로드 요청하기 성공',
  GET_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '전체 태그 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [태그 그룹 등록/편집, 태그 메인 탭 관리, 태그 트렌드 키워드 관리]
   *  선택 태그 리스트 엑셀 다운로드 요청하기
   */
  GET_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '선택 태그 리스트 엑셀 다운로드 요청하기 성공',
  GET_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '선택 태그 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [태그 그룹 등록/편집, 태그 메인 탭 관리, 태그 트렌드 키워드 관리]
   *  태그 엑셀 업로드
   */
  SET_TAG_EXCEL_UPLOAD_REQUEST_SUCCESS: '태그 엑셀 업로드 성공',
  SET_TAG_EXCEL_UPLOAD_REQUEST_ERROR: '태그 엑셀 업로드 실패',

  /**
   *  [태그 리스트] 엑셀 다운로드
   */
  GET_TAG_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '태그 리스트 엑셀 다운로드 성공',
  GET_TAG_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '태그 리스트 엑셀 다운로드 실패',
};

export default tagToastMsg;
